import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { initConsentMode, initGA } from './analytics';

// Setzt den Google-Consent-Mode-Standard (alles "denied"), bevor die App
// rendert bzw. Google Analytics geladen wird. So respektiert Google Analytics
// die Consent-Entscheidung des Nutzers und setzt Cookies erst nach
// ausdrücklicher Zustimmung.
initConsentMode();

// Lädt das gtag.js-Skript IMMER beim App-Start, unabhängig von der
// Consent-Entscheidung. Ohne geladenes Skript findet Google (z. B. der
// Tag Assistant oder die Property-Prüfung "Tag wurde nicht gefunden") den
// Google-Tag auf der Domain nicht, da dafür lediglich die Installation des
// Skripts geprüft wird – nicht, ob bereits Cookies gesetzt wurden. Der
// Consent Mode sorgt weiterhin dafür, dass ohne Einwilligung keine
// Analytics-Cookies gespeichert werden (analytics_storage bleibt "denied").
initGA();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
